import React from 'react';
import './NavBar.css';
import nepMaster from '../../assets/icons/nepmaster-logo.svg';

const NavBar: React.FC = () => {
  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="logo-container">
          <div className="brand-name">NepMaster</div>
        </div>
        <div className="nav-links">
          <a href="#contact" className="nav-link">Contact</a>
        </div>
      </div>
    </nav>
  );
};

export default NavBar;
